import React, { useEffect } from "react";
import Select from "react-select";

const unOptions = [
	{label: "Action driven", value: 'action_driven'},
	{label: "Context driven", value: 'context_driven'},
	{label: "Emotion driven", value: 'emotion_driven'},
	{label: "Fact driven", value: 'fact_driven'},
];

type Props = {
	isDisabled?: boolean,
	updateConfig: Function,
	userNeedValues: Array<string>
}

type Option = {
	value: string,
	label: string
}

const UserNeeds = (props: Props) => {

	const getSelectedOption = (values: any, items: Array<Option>) => {
		if (Array.isArray(values)) {
			return items.filter(item => values.includes(item.value));
		}
	};

	const onUserNeedChange = (value: Option[]) => {
		props.updateConfig(["user_needs"], [(!value || value.length < 1) ? [] : value.map(item => item.value)]);
	}

	useEffect(() => {
		if (props.isDisabled === true && props.userNeedValues.length !== 0) {
			props.updateConfig(['user_needs'], [[]]);
		}
	}, [props.isDisabled]);

	return (
		<div className="form-group">
			<label htmlFor="userNeeds">User needs</label>
			<Select
				id="userNeeds"
				className="basic-single"
				classNamePrefix="so-select-sort"
				isSearchable={true}
				isMulti={true}
				isDisabled={props.isDisabled}
				value={getSelectedOption(props.userNeedValues, unOptions)}
				options={unOptions}
				onChange={(option) => onUserNeedChange((option as Option[]))}
				menuPortalTarget={document.body}
				styles={{menuPortal: base => ({...base, zIndex: 9999})}}
			/>
		</div>
	);
};

export default UserNeeds;
